import * as yup from "yup";

export const TaskSchema = yup.object({
  title: yup.string().required("Task Name is required"),
  category: yup.string(),
  description: yup.string(),
  notes: yup.string(),
  assignedToUser: yup.string().required("Assign To User is required"),
  reminder: yup.string(),
  start: yup.string().required("Start Date is required"),
  end: yup.string(),
  backgroundColor: yup.string(),
  borderColor: yup.string(),
  textColor: yup.string(),
  display: yup.string(),
  url: yup
    .string()
    .matches(/^https?:\/\/.+/i, "URL must start with http:// or https://"),
  createBy: yup.string(),
});
